<dx-popup
  [width]="'90%'"
  [maxWidth]="600"
  [height]="375"
  [showTitle]="true"
  [title]="''"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="close()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <ng-container *ngIf="step === 'idd'">
      <div class="modal-text">
        <h3 class="modal-title">
          {{ 'MY-TRAININGS.SHARE-IDD-NUMBER.TITLE' | translate }}
        </h3>
        <p class="modal-description">
          {{ 'MY-TRAININGS.SHARE-IDD-NUMBER.TEXT' | translate }}
        </p>
      </div>
      <div class="step-buttons">
        <div class="btn-skip-wrapper">
          <dx-button
            class="step-btn"
            type="default"
            [text]="'COMMON.SKIP' | translate"
            (click)="skipIddNumber()"
          ></dx-button>
        </div>
        <div class="btn-share-wrapper">
          <dx-button
            class="step-btn"
            type="normal"
            [text]="'COMMON.SHARE' | translate"
            (click)="shareIddNumber()"
          ></dx-button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="step === 'calendar'">
      <img class="checkmark-icon" src="assets/img/checkmark.jpg" />
      <div class="modal-text">
        <p>{{ "MY-TRAININGS.OVERVIEW.ATTENDANCE-CONFIRMED" | translate }}</p>
      </div>
      <div class="modal-buttons">
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'MY-TRAININGS.OVERVIEW.SAVE-CALENDAR' | translate"
          (click)="addToCalendar()"
        ></dx-button>
      </div>
    </ng-container>
  </div>
</dx-popup>